import React from 'react';
import Styles from './PartiuGpSimule.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

const SIMULAR_URL =
  'https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=partiu-gp-da-inglaterra:simule&int_campaign=simular-financiamento';

const cards = [
  { titulo: 'Taxas especiais', texto: 'A partir de 1,29% ao mês' },
  {
    titulo: 'Segurança',
    texto: 'Da financeira líder de mercado, com mais de 63 anos de experiência*.',
  },
  {
    titulo: 'Condições especiais',
    texto: 'Financiamento de até 100% do valor do veículo, pagando em até 60 meses.',
  },
];

function PartiuGpSimule() {
  return (
    <section id="partiu-gp-simule">
      <ContainerHome24>
        <p className="eyebrow">Simule agora</p>
        <h2 className="titulo">Tão rápido quanto um pit stop!</h2>
        <p className="subtitulo">Descubra sua pré-aprovação em poucos passos e aproveite</p>

        <div className="cards">
          {cards.map((card) => (
            <div className="card" key={card.titulo}>
              <h3 className="card-titulo">{card.titulo}</h3>
              <p className="card-texto">{card.texto}</p>
            </div>
          ))}
        </div>

        <a href={SIMULAR_URL} target="_blank" rel="noopener" className="cta">
          Simular agora
        </a>

        <p className="disclaimer">
          *A simulação não garante participação na promoção. A participação ocorre somente após a
          contratação do financiamento e confirmação da participação conforme regulamento.
          <br />
          *Fonte: B3
        </p>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpSimule;
